module.exports = __webpack_public_path__ + "img/img-mmqr-logo.e81c5c43.png";